// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"object-storage"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M14.5 20H17.5C20 20 23 18.5 23 15C23 11.5 20 10 18 10V9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9V10C4 10 1 11.5 1 15C1 18.5 4.11768 20 6 20C7.88232 20 12 20 12 15V12.75M9.5 14L12 11.5L14.5 14","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-object-storage')
export default class ObjectStorageIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'object-storage',
    }
  }
}
